import React from 'react';
import { STATUS_META } from './paymentLinksStore';

export default function PaymentLinkStatusBadge({ status }) {
    const meta = STATUS_META[status] || STATUS_META.expired;
    return (
        <span
            className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${meta.className}`}
        >
            {meta.label}
        </span>
    );
}
